<template>
  <div class="flex w-full items-center justify-between space-x-2">
    <icon-base
      height="15"
      width="15"
      view-box="-1 0 15 15"
      class="mt-1"
      :class="
        prioritiesIconsMap[modelValue as keyof typeof prioritiesIconsMap].class
      "
      :icon="
        prioritiesIconsMap[modelValue as keyof typeof prioritiesIconsMap].icon
      "
    />
    <span class="text-headline">
      {{ option }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { prioritiesIconsMap } from "@/helpers/constants/priorities";

import IconBase from "@/components/ui/IconBase.vue";

interface Props {
  modelValue: string;
  option: string;
}

defineProps<Props>();
</script>
